var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPushPinNew = function SvgPushPinNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-3.5 -1 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.183 10.624l-.861-5.162h.674c.461 0 .836-.344.836-.768V2.932C14.832 1.315 13.399 0 11.638 0H5.015C3.254 0 1.821 1.315 1.821 2.932v1.762c0 .423.374.768.836.768h.674l-.861 5.162C.946 11.775 0 13.37 0 15.13c0 .423.374.768.836.768h14.983c.461 0 .836-.344.836-.768-.002-1.76-.948-3.356-2.472-4.506zM3.492 2.932c0-.771.683-1.398 1.523-1.398h6.622c.84 0 1.523.627 1.523 1.398v.995H3.492v-.995zm1.529 2.53h6.61l.684 4.1a10.365 10.365 0 00-3.989-.778c-1.444 0-2.803.281-3.988.777l.683-4.1zm-3.266 8.9c.51-2.29 3.262-4.044 6.571-4.044 3.309 0 6.062 1.755 6.571 4.045H1.755zM8.326 17.436c-.461 0-.836.343-.836.767v3.03c0 .423.374.767.836.767.462 0 .836-.343.836-.767v-3.03c0-.423-.375-.767-.836-.767z"
  })));
};

export default SvgPushPinNew;